import React from 'react';
export function ValueSection() {
  const items = [{
    name: '📘 Tomo 1: La Alquimia Estética',
    price: '$18.000'
  }, {
    name: '📗 Tomo 2: El Negocio Visual',
    price: '$18.000'
  }, {
    name: '🎁 Bono 1: Proveedores Gold Argentina',
    price: '$8.000'
  }, {
    name: '🎁 Bono 2: El Celular es tu Cámara',
    price: '$12.000'
  }, {
    name: '🎁 Bono 3: Paleta de Diseño 2026',
    price: '$7.000'
  }, {
    name: '🎁 Bono 4: Método WhatsApp Gold',
    price: '$9.000'
  }];
  return <section id="comprar" className="py-10 px-5 bg-negro text-center" data-id="element-185">
      <h2 className="font-playfair text-[clamp(22px,3.5vw,34px)] text-blanco mb-6" data-id="element-186">
        Todo lo que Recibís Hoy
      </h2>

      <div className="max-w-[650px] mx-auto mb-6 rounded-2xl overflow-hidden border border-[rgba(212,175,55,0.3)]" data-id="element-187">
        {items.map((item, i) => <div key={i} className="flex justify-between items-center py-2.5 px-5 border-b border-[rgba(255,255,255,0.05)] bg-[#1e1e1e] transition-colors duration-200 hover:bg-[#252525]" data-id="element-188">
            <span className="text-[14px] text-texto-claro text-left" data-id="element-189">
              {item.name}
            </span>
            <span className="text-[14px] text-dorado font-bold" data-id="element-190">
              {item.price}
            </span>
          </div>)}
        <div className="flex justify-between items-center py-3 px-5 bg-[linear-gradient(135deg,rgba(201,149,108,0.15),rgba(212,175,55,0.15))] border-t-2 border-dorado" data-id="element-191">
          <span className="text-[16px] font-bold text-blanco text-left" data-id="element-192">
            💎 VALOR TOTAL
          </span>
          <span className="text-[18px] text-dorado font-bold" data-id="element-193">$72.000</span>
        </div>
      </div>

      <div className="max-w-[450px] mx-auto bg-gradient-bonus border-2 border-dorado rounded-2xl p-6" data-id="element-194">
        <p className="text-[18px] text-[#666] line-through mb-1" data-id="element-195">
          Valor real: $72.000 ARS
        </p>
        <div data-id="element-196">
          <span className="text-[22px] text-oro-rosa font-bold" data-id="element-197">$</span>
          <span className="font-playfair text-[clamp(42px,7vw,64px)] font-black text-gradient-gold leading-none" data-id="element-198">
            19.999
          </span>
        </div>
        <p className="text-[#888] text-[13px]" data-id="element-199">pesos argentinos — Pago único</p>
        <div className="bg-gradient-teal text-negro py-1.5 px-4 rounded-full text-[13px] font-bold inline-block mt-3" data-id="element-200">
          🎉 Ahorrás $52.001 ARS — 72% de descuento
        </div>
      </div>

      <div className="mt-6" data-id="element-201">
        <a href="https://pagos.indigo33.shop/cart/44022797729880:1" target="_blank" rel="noopener noreferrer" className="inline-block bg-gradient-cta text-negro py-4 px-10 rounded-[60px] text-[clamp(16px,2.2vw,20px)] font-black no-underline tracking-[1px] transition-all duration-400 shadow-[0_15px_40px_rgba(212,175,55,0.4)] animate-pulse-cta uppercase cursor-pointer border-none hover:-translate-y-[3px] hover:scale-[1.03]" data-id="element-202">
          💎 SÍ, QUIERO ACCESO AHORA →
        </a>
      </div>

      <div className="mt-3 text-[13px] text-[#888] flex justify-center items-center gap-4 flex-wrap" data-id="element-203">
        <span className="flex items-center gap-1" data-id="element-204">
          🔒 Pago seguro con Mercado Pago
        </span>
        <span className="flex items-center gap-1" data-id="element-205">⚡ Acceso inmediato</span>
        <span className="flex items-center gap-1" data-id="element-206">
          💳 Hasta 6 cuotas sin interés
        </span>
      </div>
    </section>;
}